<template>
  <div v-if="open" class="scp" @click.self="emit('close')">
    <div class="scp__panel" role="dialog" aria-modal="true" aria-label="비밀번호 확인">
      <header class="scp__head">
        <h2 class="scp__title">비밀번호 확인</h2>
        <button type="button" class="scp__x" aria-label="비밀번호 창 닫기" @click="emit('close')">
          <AppIcon icon="mdi-close" :size="20" />
        </button>
      </header>
      <form class="scp__body" @submit.prevent="onSubmit">
        <p class="scp__lead">
          {{ reason }} 직원만 할 수 있는 동작입니다.
          비밀번호를 입력해 주세요.
        </p>
        <label class="scp__label" for="scp-password">비밀번호</label>
        <input
          id="scp-password"
          ref="inputEl"
          v-model="password"
          class="scp__input"
          type="password"
          inputmode="numeric"
          autocomplete="current-password"
          :disabled="busy"
        />
        <p v-if="error" class="scp__error" role="alert">{{ error }}</p>
        <footer class="scp__foot">
          <button type="button" class="scp__btn scp__btn--ghost" :disabled="busy" @click="emit('close')">
            닫기
          </button>
          <button type="submit" class="scp__btn scp__btn--teal" :disabled="busy || !password.trim()">
            {{ busy ? '확인 중…' : '확인' }}
          </button>
        </footer>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, ref, watch } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'

const props = defineProps<{
  open: boolean
  /** 왜 비밀번호를 묻는지 — 예: 「계약서 목록 보기」 */
  reason: string
  busy: boolean
  error: string
}>()

const emit = defineEmits<{
  close: []
  confirm: [password: string]
}>()

const password = ref('')
const inputEl = ref<HTMLInputElement | null>(null)

watch(
  () => props.open,
  (open) => {
    if (!open) {
      password.value = ''
      return
    }
    nextTick(() => inputEl.value?.focus())
  },
)

function onSubmit() {
  if (props.busy || !password.value.trim()) return
  emit('confirm', password.value.trim())
}
</script>

<style lang="scss" src="./ContractPasswordModal.scss"></style>
